import { connect, sentryEventIdSelector, showReportDialog } from '../dependencies';

import ErrorWithAction from '../components/ErrorWithAction';

const mapStateToProps = state => {
    const eventId = sentryEventIdSelector(state);

    return {
        onErrorMessageClick() {
            showReportDialog({ eventId });
        },
        error: {
            id: 'error.internal',
        },
        buttonTextId: 'app.reportFeeback',
    };
};

export default connect(mapStateToProps)(ErrorWithAction);
